import React, { useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useDownloadExcel } from 'react-export-table-to-excel';
import _ from 'lodash';
import {
  IApiListResult,
  IApiResult,
  IOptionItem,
  ILeftMenu,
  ILoginUser,
  IMatchMenuIdPageId,
  ISelect,
  ITableColumn,
  IPageContent,
  IComponentModal,
  IModal,
  ITablePaging,
} from '../interfaces/app.interface';
import { loginStore } from '../stores/login.store';
import { selectedPageStore } from '../stores/selectedPage.store';
import { modalStore, removeModalStore } from '../stores/modal.store';
import { PageLayout } from '../components/PageLayout';
import * as cmnApi from '../apis/cmn.api';
import moment from 'moment';
import { PbButton } from '../components/PbButton';
import { PbTable } from '../components/PbTable';
import { PbFormGrid } from '../components/PbFormGrid';
import { PbFormGridCol } from '../components/PbFormGridCol';
import { pageContentStore } from '../stores/page.store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  addComponentModalStore,
  componentModalStore,
  removeComponentModalStore,
} from '../stores/componentModal.store';
import { MN2302220860 } from '../components/MN2302220860';
import { nanoid } from 'nanoid';
import { Button, Select, TextInput } from '@mantine/core';
import {
  refreshListStore,
  removeRefreshListStore,
} from '../stores/refreshList.store';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import { AgGridReact } from 'ag-grid-react';
import { DatePickerInput } from '@mantine/dates';
import { PbAgGridReact } from '../components/PbAgGridReact';
import PbSelect from '../components/PbSelect/PbSelect.component';

/**
 * 시스템 관리 > 권한 그룹 관리
 * @constructor
 */
const MN2302220803Page = () => {
  // 언어를 정의함
  const { t } = useTranslation();

  // 로그인한 사용자 저장소를 정의함
  const [loginUser, setLoginUser] = useRecoilState<ILoginUser>(loginStore);

  // 선택한 페이지 저장소를 정의함
  const [selectedPage, setSelectedPage] =
    useRecoilState<ILeftMenu>(selectedPageStore);

  // 페이지 내용 저장소를 정의함
  const [pageContent, setPageContent] =
    useRecoilState<IPageContent>(pageContentStore);

  // 모달 저장소를 정의함
  const [modal, setModal] = useRecoilState<IModal>(modalStore);

  // 삭제할 모달 저장소를 정의함
  const [removeModal, setRemoveModal] = useRecoilState<any>(removeModalStore);

  // 추가할 컴포넌트 모달 저장소를 정의함
  const [addComponentModal, setAddComponentModal] =
    useRecoilState<IComponentModal | null>(addComponentModalStore);

  // 삭제할 컴포넌트 모달 저장소를 정의함
  const [removeComponentModal, setRemoveComponentModal] = useRecoilState<
    string | null
  >(removeComponentModalStore);

  // 목록 새로고침 저장소를 정의함
  const [refreshList, setRefreshList] =
    useRecoilState<string[]>(refreshListStore);

  // 삭제할 목록 새로고침 저장소를 정의함
  const [removeRefreshList, setRemoveRefreshList] = useRecoilState<string>(
    removeRefreshListStore,
  );

  /**
   * 상단 등록
   */
  // 페이지 상단바 > 등록 버튼을 클릭함
  const handleRegButton_onChange = () => {
    let tmpId: string = 'MN2302220860';

    // 컴포넌트 모달을 추가함
    setAddComponentModal({
      id: tmpId,
      title: '권한 그룹 등록',
      content: <MN2302220860 id={tmpId} webType="WEB" />,
      size: 1500,
    });
  };
  /* // 상단 등록 */

  /**
   * 검색어 입력
   */

  // 검색어 > 검색어 텍스트 입력을 정의함
  const [searchTextInput, setSearchTextInput] = useState<string>('');

  // 검색 폼 그리드 > 검색어 입력의 값을 변경함
  const handleClientSearchInput_onChange = (event: any) => {
    setSearchTextInput(event.target.value);
  };

  // /* // 검색어 입력 */

  // /**
  //  * 검색 / 검색 조건 초기화 / 상세검색 열기 / 상세검색 닫기
  //  */

  // 상세검색 나타냄을 정의함
  const [hideDetailSearch, setHideDetailSearch] = useState<boolean>(false);

  // 검색 폼 그리드 > 검색어 > 상세검색 열기닫기 버튼을 클릭함
  const handleShowSearchDetailButton_onChange = () => {
    setHideDetailSearch(!hideDetailSearch);
  };

  // 검색 폼 그리드 > 검색어 > 검색 버튼을 클릭함
  const handleSearchButton_onChange = () => {
    // 테이블의 페이지를 변경함
    searchResultTablePagingCurrentPageRef.current = 1;
    setSearchResultTablePaging((pre: ITablePaging) => ({
      ...pre,
      currentPage: searchResultTablePagingCurrentPageRef.current,
    }));

    // 검색 결과 테이블 데이터를 불러옴
    getSearchResultTableData();
  };

  // 검색 폼 그리드 > 검색어 > 검색 조건 초기화 버튼을 클릭함
  const handleSearchCancelButton_onChange = () => {
    // 검색 폼 그리드 > 검색어 > 검색어 입력 값을 초기화함
    setSearchTextInput('');

    // 상세 검색 > 등록기간 > 날짜 피커 값을 초기화함
    initDatePicker();

    // 상세 검색 > 사용 여부 셀렉트 값을 초기화함
    initUseYnSelect();
  };

  /* // 검색 / 검색 조건 초기화 / 상세검색 열기 / 상세검색 닫기 */

  /**
   * 등록 기간 - Date Picker
   */

  // 상세검색 > 등록기간을 정의함
  // 상세검색 > 등록기간 의 년월 피커를 변경함
  const [searchAddDatePicker, setSearchAddDatePicker] = useState<
    [Date | null, Date | null]
  >([null, null]);

  const handleSearchAddDatePicker_onChange = (event: any) => {
    setSearchAddDatePicker(event);
  };

  // 상세검색 > 등록기간 날짜 피커의 값을 초기화함
  const initDatePicker = () => {
    // 오늘 날짜를 불러옴
    let today: string = moment().format('YYYY-MM-DD');

    // 한달 전 날짜를 불러옴
    // let pastDay: string = moment().subtract(90, 'd').format('YYYY-MM-DD');
    let pastDay: string = moment('20000101').format('YYYY-MM-DD');

    // 상세 검색 > 등록기간 > 날짜 피커 값을 초기화함
    setSearchAddDatePicker([
      moment(pastDay, 'YYYY-MM-DD').toDate(),
      moment(today, 'YYYY-MM-DD').toDate(),
    ]);
  };

  /* // 등록 기간 - Date Picker */

  /**
   * 사용 여부 - Select box
   */

  // 상세 검색 > 사용 여부 셀렉트를 정의함
  const [useYnSelect, setUseYnSelect] = useState<ISelect>({
    value: '',
    item: [],
  });

  // 상세 검색 > 사용 여부 셀렉트에서 선택한 아이템을 변경함
  const handleUseYnSelect_onChange = (event: any) => {
    setUseYnSelect((pre: ISelect) => ({
      ...pre,
      value: event,
    }));
  };

  // 상세 검색 > 사용 여부 셀렉트의 아이템을 초기화함
  const initUseYnSelect = () => {
    let tmpOptionItem: IOptionItem[] = [];

    tmpOptionItem.push(
      {
        label: '전체',
        value: '',
      },
      {
        label: '사용',
        value: 'Y',
      },
      {
        label: '미사용',
        value: 'N',
      },
    );

    // 상세 검색 > 사용 여부 셀렉트의 아이템에 적용함
    setUseYnSelect({
      value: '',
      item: tmpOptionItem,
    });
  };

  /* // 사용 여부 - Select box */

  /**
   * 검색 결과 테이블
   */

  // 검색 결과 테이블을 정의함
  const [searchResultTable, setSearchResultTable] = useState<{
    column: any;
    data: any;
  }>({ column: [], data: [] });

  // 검색 결과 테이블 페이징을 정의함
  const [searchResultTablePaging, setSearchResultTablePaging] =
    useState<ITablePaging>({
      totalPage: 1,
      totalRow: 0,
      rowPerPage: 10,
      currentPage: 1,
    });
  const searchResultTablePagingCurrentPageRef = useRef<number>(1);

  // 검색 결과 테이블의 로딩 여부를 정의함
  const [searchResultTableLoading, setSearchResultTableLoading] =
    useState<boolean>(false);

  // 검색 결과 테이블을 초기화함
  const initSearchResultTable = () => {
    // 컬럼을 생성함
    let tmpColumn: any = [];

    // 컬럼에 추가함
    tmpColumn.push(
      {
        field: 'no',
        headerName: '번호',
        width: 80,
        suppressSizeToFit: true,
      },
      {
        field: 'thrtGrpName',
        headerName: '권한 그룹명',
      },
      {
        field: 'thrtName',
        headerName: '권한명',
      },
      {
        field: 'useYn',
        headerName: '사용 여부',
        width: 100,
        suppressSizeToFit: true,
      },
      {
        field: 'rgstDate',
        headerName: '등록일',
        width: 130,
        suppressSizeToFit: true,
      },
      {
        field: 'mdfcDate',
        headerName: '수정일',
        width: 130,
        suppressSizeToFit: true,
      },
    );

    // 검색 결과 테이블에 적용함
    setSearchResultTable((pre: { column: any; data: any }) => ({
      ...pre,
      column: tmpColumn,
    }));
  };

  // 검색 결과 테이블의 행을 클릭함
  const handleSearchResultTable_onRowDoubleClicked = (row: any) => {
    let tmpId: string = 'MN2302220860';

    // 컴포넌트 모달을 추가함
    setAddComponentModal({
      id: tmpId,
      title: '권한 그룹 상세',
      content: (
        <MN2302220860 id={tmpId} thrtGrpId={row.data.thrtGrpId} webType="WEB" />
      ),
      size: 1500,
    });
  };

  /**
   * 처리
   */
  // 검색 결과 테이블 데이터를 불러옴
  const getSearchResultTableData = () => {
    // 검색 결과 테이블의 로딩 여부에 적용함
    setSearchResultTableLoading(true);

    cmnApi
      .getAuthorityGroups({
        thrtGrpName: searchTextInput.trim(), // 검색어
        rgstStDt: searchAddDatePicker[0]
          ? moment(searchAddDatePicker[0]).format('YYYYMMDD')
          : '', // 등록 시작일
        rgstEnDt: searchAddDatePicker[1]
          ? moment(searchAddDatePicker[1]).format('YYYYMMDD')
          : '', // 등록 종료일
        useYn: useYnSelect.value, // 사용여부 코드
        pageSize: searchResultTablePaging.rowPerPage,
        currPageIdx: searchResultTablePagingCurrentPageRef.current,
      })
      .then((data: IApiResult) => {
        if (data.data.list !== undefined) {
          // 검색 결과 테이블에 적용함
          setSearchResultTable(
            (pre: { column: ITableColumn[]; data: any }) => ({
              ...pre,
              data: data.data.list,
            }),
          );

          // 테이블을 페이징함
          setSearchResultTablePaging((pre: ITablePaging) => ({
            ...pre,
            totalPage: data.data.page.totPageCnt,
            totalRow: data.data.page.totItemCnt,
          }));
        }

        // 검색 결과 테이블의 로딩 여부에 적용함
        setSearchResultTableLoading(false);
      });
  };
  /* //처리 */

  /* // 검색 결과 테이블 */

  /**
   * useEffect
   */

  // 페이지 로딩 후 한번만 실행함
  useEffect(() => {
    //initial states
    // 권한 그룹명 > 검색어 입력 값을 초기화함
    setSearchTextInput('');

    // 상세 검색 > 등록기간 > 날짜 피커 값을 초기화함
    initDatePicker();

    // 상세 검색 > 사용여부 셀렉트 값을 초기화함
    initUseYnSelect();

    // 검색 결과 테이블을 초기화함
    initSearchResultTable();

    return () => {};
  }, []);

  // 검색 결과 테이블이 초기화된 후 실행함
  useEffect(() => {
    if (searchResultTable.column.length === 0) {
      return;
    }

    // 검색 결과 테이블 데이터를 불러옴
    getSearchResultTableData();

    return () => {};
  }, [searchResultTable.column]);

  // 목록 새로고침이 변경될 때 실행함
  useEffect(() => {
    if (refreshList.length === 0) {
      return;
    }

    if (_.indexOf(refreshList, 'MN2302220803Table') > -1) {
      // 테이블의 페이지를 변경함
      searchResultTablePagingCurrentPageRef.current = 1;
      setSearchResultTablePaging((pre: ITablePaging) => ({
        ...pre,
        currentPage: searchResultTablePagingCurrentPageRef.current,
      }));

      // 검색 결과 테이블 데이터를 불러옴
      getSearchResultTableData();

      // 목록 새로고침 목록에서 제거함
      setRemoveRefreshList('MN2302220803Table');
    }

    //initial states
    // 검색 폼 그리드 > 검색어 > 검색어 입력 값을 초기화함
    setSearchTextInput('');

    return () => {};
  }, [refreshList]);

  /* // useEffect */

  return (
    <PageLayout
      pageInfoBarCenterArea={<></>}
      pageInfoBarRightArea={
        <>
          {/* 버튼 */}
          <Button color="indigo" radius="xl" onClick={handleRegButton_onChange}>
            등록
          </Button>
        </>
      }
      enablePageInfoBarBackgroundColor={true}
    >
      {/* 페이지 내용 */}
      <div className="">
        {/* 검색 */}
        <div className="space-y-5">
          {/* 검색 폼 그리드 */}
          <PbFormGrid label="검색" cols={2}>
            <PbFormGridCol label="권한 그룹명" colSpan={2}>
              {/* 검색어 텍스트 입력 */}
              <TextInput
                placeholder="검색어를 입력하세요."
                size="sm"
                onChange={handleClientSearchInput_onChange}
                value={searchTextInput}
                className="w-1/5"
              />

              {/* 버튼 */}
              <div className="flex justify-center items-center space-x-2">
                {/* 버튼 */}
                <Button
                  color="indigo"
                  radius="xl"
                  onClick={handleSearchButton_onChange}
                >
                  검색
                </Button>

                {/* 버튼 */}
                <Button
                  variant="outline"
                  color="gray"
                  radius="xl"
                  onClick={handleSearchCancelButton_onChange}
                >
                  검색 조건 초기화
                </Button>

                {/* 버튼 */}
                <Button
                  variant="outline"
                  color="gray"
                  radius="xl"
                  onClick={handleShowSearchDetailButton_onChange}
                >
                  {hideDetailSearch ? (
                    <>
                      상세검색 열기
                      <div className="ml-1 flex justify-center items-center">
                        <FontAwesomeIcon
                          icon={['fas', 'caret-down']}
                          className="w-5 h-5"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      상세검색 닫기
                      <div className="ml-1 flex justify-center items-center">
                        <FontAwesomeIcon
                          icon={['fas', 'caret-up']}
                          className="w-5 h-5"
                        />
                      </div>
                    </>
                  )}
                </Button>
              </div>
            </PbFormGridCol>
            {/*<PbFormGridCol label="등록기간" isHidden={hideDetailSearch}>*/}
            {/*  <DatePickerInput*/}
            {/*    type="range"*/}
            {/*    placeholder="요청기간을 선택하세요."*/}
            {/*    onChange={handleSearchAddDatePicker_onChange}*/}
            {/*    value={searchAddDatePicker}*/}
            {/*    valueFormat="YYYY.MM.DD"*/}
            {/*    locale="ko"*/}
            {/*    clearable={true}*/}
            {/*    className="w-full"*/}
            {/*  />*/}
            {/*</PbFormGridCol>*/}
            <PbFormGridCol label="사용 여부" isHidden={hideDetailSearch}>
              {/* 셀렉트 */}
              <PbSelect
                onChange={handleUseYnSelect_onChange}
                data={useYnSelect.item}
                value={useYnSelect.value}
                setSelect={setUseYnSelect}
                className="w-full"
              />
            </PbFormGridCol>
            <PbFormGridCol label="사용 여부" isBlank={true}></PbFormGridCol>
          </PbFormGrid>

          {/* 테이블 */}
          <div className="space-y-3">
            <div className="flex justify-between items-center space-x-5">
              <div></div>

              <div className="flex justify-center items-center space-x-5">
                <div className="flex justify-center items-center">
                  <span className="text-base text-gray-600 font-bold">
                    총 {searchResultTablePaging.totalRow}건
                  </span>
                </div>
              </div>
            </div>

            {/* 테이블 */}
            <div className="w-full h-160">
              <PbAgGridReact
                columnDefs={searchResultTable.column}
                rowData={searchResultTable.data}
                loading={searchResultTableLoading}
                setLoading={setSearchResultTableLoading}
                onRowDoubleClicked={handleSearchResultTable_onRowDoubleClicked}
                defaultColDef={{
                  resizable: true,
                  sortable: true,
                  wrapHeaderText: false,
                  autoHeaderHeight: true,
                }}
                rowSelection="single"
                sizeColumnsToFit={true}
                visiblePaging={true}
                paging={{
                  totalPage: searchResultTablePaging.totalPage,
                  currentPage: searchResultTablePaging.currentPage,
                }}
                onChangePage={(event: any) => {
                  // 테이블의 페이지를 변경함
                  searchResultTablePagingCurrentPageRef.current = event;
                  setSearchResultTablePaging((pre: ITablePaging) => ({
                    ...pre,
                    currentPage: searchResultTablePagingCurrentPageRef.current,
                  }));

                  // 검색 결과 테이블 데이터를 불러옴
                  getSearchResultTableData();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MN2302220803Page;
